/**
* Created by gary on 26/10/2016.
*/
var teamService = require('teamService'),
formValidation = require('formValidation'),
loader = require('loader');

var editTeamInfo = (function() {
  $('#update-team-information').on('click', function(e) {
    e.preventDefault();
    $('window').showLoader();

    var temp = $('#team_name');
    var teamName = temp.val();
    var teamId = temp.attr('data-team-id');
    var teamAgeGroup = $('#team_age_group').val();
    var teamBio = $('#team_bio').val();
    var teamLeague = $('#team_league').val();
    var teamAddressType = $('#team_address_type').val();
    var teamAddressLine1 = $('#team_address_line1').val();
    var teamAddressLine2 = $('#team_address_line2').val();
    var teamAddressCity = $('#team_address_city').val();
    var teamAddressPostcode = $('#team_address_postcode').val();

    updateTeamInfoService(teamId, teamName, teamBio, teamAddressLine1, teamAddressLine2,
      teamAddressPostcode, teamAddressCity, teamAddressType, teamLeague, teamAgeGroup,successFn);
    });



    var successFn = function(response) {
      if (response.statusCode === 200) {
        $('window').notification({
          title: response.message,
          error: false
        });
      } else {
        $('window').notification({
          title: response.message,
          error: true
        });
      }
    };
  });
  editTeamInfo();



// WEBPACK FOOTER //
// ./library/js/modules/edit-team.js